module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Présentation")])], 1), _c('span', [_vm._v(" |")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ressources"
    }
  }, [_vm._v("Ressources")])], 1), _c('span', [_vm._v(" |")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/processing"
    }
  }, [_vm._v("Processing")])], 1), _c('span', [_vm._v(" |")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/jingle"
    }
  }, [_vm._v("Jingle")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-359503d1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainNav.vue
// module id = 103
// module chunks = 1